<template>
	<span style="margin-right:10px">
    <input id="inputFile"  class="input-file" type="file" @change="exportData"
           accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref="excelInput" />
    <el-button type="primary" size="mini" icon="el-icon-upload" @click="btnClick">点击上传</el-button>
  </span>
</template>

<script>
import XLSX from 'xlsx';

export default {
  data() {
    return {
    };
  },
  methods: {
    btnClick() {
      document.querySelector('.input-file').click();
    },
    exportData(event) {
      if (!event.currentTarget.files.length) {
        return;
      }
      const that = this;
      that.$emit('getResultOfSheet', '', 'start', '', '');
      // 拿取文件对象
      const f = event.currentTarget.files[0];
      const fileName = f.name; // 文件名称
      // 用FileReader来读取
      const reader = new FileReader();
      // 重写FileReader上的readAsBinaryString方法
      // eslint-disable-next-line
      FileReader.prototype.readAsBinaryString = function (ff) {
        let binary = '';
        let wb; // 读取完成的数据
        let outdata; // 你需要的数据
        // const reader = new FileReader();
        // eslint-disable-next-line
        reader.onload = function () {
          // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
          const bytes = new Uint8Array(reader.result);
          const length = bytes.byteLength;
          // 计算文件大小 parseFloat(value).toFixed(2)
          const fileSize = parseFloat(length / 1024 / 1024).toFixed(2);
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          // 接下来就是xlsx了，具体可看api
          wb = XLSX.read(binary, {
            type: 'binary'
          });
          for (let i = 0; i < wb.SheetNames.length; i++) {
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[i]]);
            that.$emit('getResultOfSheet', outdata, wb.SheetNames[i], fileName, fileSize);// 自定义方法向父组件传递数据
          }
        };
        reader.readAsArrayBuffer(ff);
      };
      reader.readAsBinaryString(f);
      this.$refs.excelInput.value = null;
      event.currentTarget.files = null;
    }
  }
};
</script>

<style>
  .input-file {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/import/inputExcel.vue